import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FlyingRobots from '../components/FlyingRobots';
import { WarehouseAgentView } from '../components/warehouse/WarehouseAgentView';

export default function WarehouseAgentDashboard() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#050506] text-white relative min-h-screen">
      <FlyingRobots />
      <Navbar />

      <main className="pt-[100px] pb-20">
        <div className="px-6">
          {/* Header */}
          <div className="mx-auto max-w-[1600px] mb-12">
            <p className="eyebrow text-white/50 mb-2">WAREHOUSE MANAGEMENT</p>
            <h1 className="h-display text-[48px] md:text-[56px] leading-[1.1] mb-4">
              Central Warehouse + 14 Branches
            </h1>
            <p className="text-white/60 text-[16px] max-w-[640px]">
              Real-time inventory visibility across all locations. AI agents recommend replenishment
              decisions. Approve shipments instantly.
            </p>
          </div>

          <WarehouseAgentView />
        </div>
      </main>

      <Footer />
    </div>
  );
}
